import axios from "axios";
const CHART_DETAIL_ENDPOINT = "/api/chart/data/";
const PEEL_HUNT_SECTORS = "/api/chart/sector/list/";
const PEEL_HUNT_TABLE = "/api/chart/table/data/columns/";
const CHART_UPDATE_DATA = "/api/chart/update/";
const CHART_DOWNLOAD_DATA = "/api/chart/download/";
const CHART_DETAIL_HISTORICAL_ENDPOINT = "/api/chart/historical/data/";
const CHART_DETAIL_HISTORICAL_SAVE_ENDPOINT =
  "/api/chart/make-current/version/";

axios.defaults.timeout = 3600000 

export default {
  saveChartHistoricalDetail(data) {
    // console.log("data++++++++++++", data);
    data = { ...data };
    delete data.chartName;
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${CHART_DETAIL_HISTORICAL_SAVE_ENDPOINT}`,
      data
    );
  },
  getChartHistoricalDetail(data) {
    // console.log("data++++++++++++", data);
    data = { ...data };
    delete data.chartName;
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${CHART_DETAIL_HISTORICAL_ENDPOINT}`,
      data
    );
  },
  getChartDetail(chartId) {
    return axios.get(
      `${process.env.VUE_APP_CONTEXTPATH}${CHART_DETAIL_ENDPOINT}${chartId}/`
    );
  },
  getChildrenInfoByParentName(parent) {
    return axios.get(
      `${process.env.VUE_APP_CONTEXTPATH}/api/chart/${parent}/children/`
    );
  },
  // Add form data API
  chartUpdateUploadService(token, data) {
    // console.log("serviceeeeeeee", data);
    return axios.put(
      `${process.env.VUE_APP_CONTEXTPATH}${CHART_UPDATE_DATA}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  chartDownloadService(token, data) {
    // console.log("serviceeeeeeee", data);
    return axios.get(
      `${process.env.VUE_APP_CONTEXTPATH}${CHART_DOWNLOAD_DATA}/${data}`
    );
  },
  getPeelHuntSectorAPI() {
    console.log("getPeelHuntSectorAPI");
    return axios.get(`${process.env.VUE_APP_CONTEXTPATH}${PEEL_HUNT_SECTORS}`);
  },
  getPeelhuntSectorsNameList() {
    return axios.get(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/GetSectorMaster`
    );
  },
  getCustomIndexDropdown() {
    return axios.get(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/GetCustomIndexComboFill`
    );
  },
  getPeelhuntTableList(data) {
    return axios.get(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/GetCompanyDetails?SectorId=` +
        data.SectorID
    );
  },
  getPeelhuntCustomIndexData(data) {
    return axios.post(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/GetCustomIndex`, data
    );
  },
  getPeelhuntPricePerformanceData(data, url) {
    return axios.post(
      `${process.env.VUE_APP_DOMAIN_URL}/peelhuntdotnet/fs/api/PeelHunt/${url}`, data
    );
  },
};
